import type { AuthorLevelId } from '@/features/original-plus/constants/author-levels.constants';

/** Якорь формы подачи заявки на странице Ориджинал Плюс. */
export const originalPlusApplicationFormId = 'podacha-zayavki';

export function originalPlusApplicationFieldId(fieldSuffix: string) {
  return `${originalPlusApplicationFormId}-${fieldSuffix}`;
}

export const originalPlusApplicationRulesHref = '/application_review_rules.pdf';

export const applicationFormConsultationLevelId = 'consultation' as const;

export const applicationFormConsultationOption = {
  id: applicationFormConsultationLevelId,
  title: 'Пока не знаю, хочу консультацию',
} as const;

export type ApplicationFormLevelId = AuthorLevelId | typeof applicationFormConsultationLevelId;

export const applicationFormLevelLabels: Record<AuthorLevelId, string> = {
  start: 'Старт – публикация и дистрибуция',
  growth: 'Рост – продвижение и сборники',
  pro: 'Профи – медиа и офлайн',
  production: 'Продюсирование – развитие IP',
};

export function getApplicationFormParticipationDescription(
  levelId: ApplicationFormLevelId,
): string {
  if (levelId === applicationFormConsultationLevelId) {
    return applicationFormConsultationOption.title;
  }

  return applicationFormLevelLabels[levelId];
}
